import React from 'react';
import clsx from 'clsx';
import {Box, Avatar, Chip} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import {
  ConnectionObj,
  MessageDataObj,
  MessageType,
} from 'types/models/apps/Chat';
import useStyles from './MessageItem.style';
import {GetMessage} from './MessageComponent';

// Matches the name ChatPanel.tsx actually sets on real AI replies --
// previously a different literal ("DECAIA Assistant"), which only ever
// showed up for the misrouted-sender-id bug (fixed in JWTAuth.ts), not for
// genuine AI replies (those always carry a real sender.name already).
const BOT_DISPLAY_NAME = 'AI Assistant';

interface ReceiverMessageItemProps {
  selectedUser: ConnectionObj;
  item: MessageDataObj;
}

const ReceiverMessageItem: React.FC<ReceiverMessageItemProps> = ({
  selectedUser,
  item,
}) => {
  const classes = useStyles();
  return (
    <Box
      className={clsx(classes.messageItemRoot, 'left')}
      display='flex'
      justifyContent={'flex-start'}>
      <Box className={classes.messageChatRoot}>
        <Box
          className={clsx(classes.messageTime, 'message-time')}
          component='span'>
          {item.sender.name || BOT_DISPLAY_NAME}, {item.time}
        </Box>

        <Box display='flex' flexDirection='row'>
          <Box className={classes.messageChat}>
            {selectedUser.image ? (
              <Avatar
                className={classes.profilePic}
                src={'/assets/images/avatar/bot-icon.gif'}
              />
            ) : (
              <Avatar className={classes.profilePic}>
                {item.sender.name?.charAt(0).toUpperCase()}
              </Avatar>
            )}

            <Box className='message-info'>
              {GetMessage(item, classes)}
              {item.edited && (
                <Box className={classes.editRoot}>
                  <EditIcon />
                </Box>
              )}
              {item.sources && item.sources.length > 0 && (
                <Box className={classes.sourcesRoot}>
                  <Box className={classes.sourcesLabel}>Sources</Box>
                  <Box display='flex' flexWrap='wrap'>
                    {item.sources.map((source, index) => (
                      <Chip
                        key={index}
                        size='small'
                        variant='outlined'
                        className={classes.sourceChip}
                        icon={<DescriptionOutlinedIcon />}
                        label={source}
                      />
                    ))}
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
          {item.message_type === MessageType.DOC ? (
            <Box className='pointer' component='span' mt='auto'>
              <a href={item.media!.url} download={item.media!.file_name}>
                <img alt='' src={'/assets/images/icon-download.svg'} />
              </a>
            </Box>
          ) : null}
        </Box>
        {typeof item.processing_time === 'number' && (
          <Box className={classes.processingTime}>
            Answered in {item.processing_time.toFixed(1)}s
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ReceiverMessageItem;
